module.exports = __webpack_public_path__ + "img/up.b68f3d2c.png";